export function getElementPath(element: HTMLElement): string {
    const segments = [];

    let cursor = element;

    while (cursor && cursor.id !== 'router-view') {
        if (cursor.dataset?.sliceName) {
            segments.push(cursor.dataset.sliceName);
        }

        cursor = cursor.parentElement;
    }

    return segments.reverse().join(' > ');
}

export function compileDynamicPageDLParams(store: any) {
    const page = store.state.pages.page;

    const types = store.state.pages.types?.items.find((x) => x.id === page.type_id);
    const audience = store.state.pages.audiences?.items.find((x) => x.id === page.audience_id);
    const product = store.state.products.items?.[page.product_id];

    return {
        DL_PageType: types?.name,
        DL_Audience: audience?.name,
        DL_Product: product?.name,
    };
}

export function convertRCAudience(audiences: { slug: string }[] = []): string | null {
    if (audiences.length === 0) return null;

    if (audiences.length > 1) return 'Split';

    if (audiences[0].slug === 'homeusers') return 'Consumer';
    if (audiences[0].slug === 'customers') return 'Corporate';
    if (audiences[0].slug === 'partners') return 'Cloud';

    return null;
}

export function compileRCResourceParams(store: any) {
    const resource = store.state.resourceCenter.resource.items[0];

    if (!resource) return {};

    return {
        rcProduct: resource.products?.[0]?.name,
        rcFeatured: Boolean(resource.is_featured),
        rcCategory: resource.type.slug,
        rcType: resource.is_gated ? 'Gated' : 'Ungated',
    };
}

export interface VWOParams {
    enabled: boolean;
    pollMaxAttempts: number;
    pollInterval: number;
}

export function compileVWOParams(store: any, locale: string): VWOParams {
    const settings = store.state.pages?.page?.settings ?? {};

    const vwoLocales = settings.vwo_ab_test_enabled;
    const vwoTestsEnabled = Array.isArray(vwoLocales) && vwoLocales.some(
        (x) => x === 'all' || x === locale,
    );
    return {
        enabled: vwoTestsEnabled,
        pollMaxAttempts: settings.vwo_check_attempts ?? 30,
        pollInterval: settings.vwo_check_interval ?? 50,
    };
}
